import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

var contain = false
var showLogoLogin = true

var headerTextDark = true

switch (window.env.VUE_APP_AMBIENTE) {
  case 'bioset':
    // themes = {
    //  light: {
    //    primary: colors.amber,
    //    secondary: '#F4F4F5',
    //    accent: colors.blue.accent1,
    //    error: colors.red.accent2,
    //    info: colors.blue,
    //    success: colors.green,
    //    warning: colors.amber
    //  }
    // }
    break
  case 'htm':
    themes = {
      light: {
        primary: '#50524E',
        secondary: '#595959',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    headerTextDark = false
    contain = true
    showLogoLogin = false
    break
  case 'eosfin':
    themes = {
      light: {
        primary: '#0080e3',
        secondary: '#5eb45e',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
      dark: {
        primary: colors.blue.darken2,
        secondary: colors.grey.lighten2,
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
}

let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'
let logoHeader = '/assets/imgs/logo-inverted.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
  }
} catch { }
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'
    logoHeader = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'
    if (window.env.VUE_APP_AMBIENTE === 'bioset') {
      logoHeader = '/assets/imgs/logo-inverted.svg'
    }

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
  }
} catch { }

var isHeaderBranco = ['htm', 'eosfin']

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    toolbar: { color: isHeaderBranco.find(p => p === localStorage.ambiente) ? '#F4F4F5' : themes.light.primary, dark: headerTextDark }
  },
  background,
  logo,
  logoHeader,
  viewOptions: {
    Home: {
      backgroundContain: contain
    },
    Login: {
      showLogoLogin: showLogoLogin
    }
  },
  themes: themes
}
